<script setup lang="ts">
import {Menu, X} from 'lucide-vue-next';
import {ref} from 'vue';
import {RouterLink} from 'vue-router';
import CompanyLogo from './CompanyLogo.vue';
import {useLanguage} from '../composables/useLanguage';
import {navigationItems} from '../config/navigation';

const {isArabic, toggleLocale} = useLanguage();
const menuOpen = ref(false);

const close = () => {
  menuOpen.value = false;
};
</script>

<template>
  <header class="navbar-shell">
    <div class="container navbar">
      <CompanyLogo />
      <nav :class="['nav-links', {open: menuOpen}]" aria-label="Main navigation">
        <RouterLink v-for="item in navigationItems" :key="item.name" :to="item.path" @click="close">
          {{ isArabic ? item.ar : item.en }}
        </RouterLink>
        <RouterLink to="/contact" class="button button--small button--primary" @click="close">
          {{ isArabic ? 'اطلب عرضاً' : 'Request a quote' }}
        </RouterLink>
        <button class="language-button nav-lang-toggle" type="button" @click="toggleLocale">{{ isArabic ? 'EN' : 'عربي' }}</button>
      </nav>
      <button class="menu-button" type="button" :aria-expanded="menuOpen" @click="menuOpen = !menuOpen">
        <X v-if="menuOpen" />
        <Menu v-else />
      </button>
    </div>
  </header>
</template>
